export default {
	color: {
		red: '#D93F39',
		green: '#C1D72D',
		teal: '#00AAA7',
		purple: '#594B69',
		darkPurple: '#494156',
		dark: '#36323F',
		yellow: '#FCD366',
	},
	fonts: {
		heading: 'Lilita One, cursive',
		body: 'Quicksand, sans-serif',
	},
};
